export default "__VITE_ASSET__BNny3J1N__"